module.exports = __webpack_public_path__ + "img/STEP4.f75f0097.png";